import { SagaIterator } from 'redux-saga'
import { call, fork, put, takeLatest } from 'redux-saga/effects'
import { GET_PATIENTS_ADMISSIONS_LIST } from './actionTypes'
import { getPatientsData } from './api'
import {
  addPatientAdmissions,
  errorPatientAdmissions,
} from './patientAdmissionReducer'

export function* handleGetPatientsAdmissionData(): SagaIterator<void> {
  try {
    const response = yield call(getPatientsData)
    const { data } = response
    let unmodifiedData = data.patientAdmissions

    yield put(addPatientAdmissions(unmodifiedData))
  } catch (error: any) {
    yield put(errorPatientAdmissions(error.response.data.message))
  }
}

export function* watcherSaga() {
  yield takeLatest(GET_PATIENTS_ADMISSIONS_LIST, handleGetPatientsAdmissionData)
}

export const patientAdmissionsSaga = [fork(watcherSaga)]
